// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ugGL","question":"styles_question__3VJ5U","inputVisibleButton":"styles_inputVisibleButton__G3M5K","note":"styles_note__3EB48"};